import React, { useState, useRef, useEffect } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./dropstyle.css";

const CustomDropdown = ({
  value,
  onChange,
  options,
  placeholder,
  width,
  icon, // single icon for all
  returnObject = false, // new prop: if true, returns full object
  props,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    minWidth: 0,
  });

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    if (!dropdownOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.right + 200 > window.innerWidth ? rect.left : rect.left,
        minWidth: rect.width,
      });
    }
    setDropdownOpen((prev) => !prev);
  };

  const handleOptionClick = (option, e) => {
    e.stopPropagation();
    if (returnObject) {
      onChange(option); // return full object
    } else {
      onChange(option.value); // return only value
    }
    setDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = returnObject
    ? value // full object
    : options.find((opt) => opt.value === value); // primitive value

  return (
    <>
      {/* Dropdown Button */}
      <div
        ref={buttonRef}
        onClick={toggleDropdown}
        className="dropnewBtn"
        style={{
          width: width || "200px",
          ...props,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "1rem",
            color: value ? "var(--primary-color)" : "var(--text-color)",
          }}
        >
          {icon && (
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#22ccb2",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                margin: 0,
                padding: 1,
              }}
            >
              {icon}
            </span>
          )}
          <span>{selectedOption ? selectedOption.label : placeholder}</span>
        </div>

        {dropdownOpen ? (
          <KeyboardArrowUpIcon
            style={{
              color: value ? "var(--primary-color)" : "var(--text-color)",
            }}
          />
        ) : (
          <KeyboardArrowDownIcon
            style={{
              color: value ? "var(--primary-color)" : "var(--text-color)",
            }}
          />
        )}
      </div>

      {/* Dropdown Options */}
      {dropdownOpen && (
        <div
          ref={dropdownRef}
          className="bxShadowdrp"
          style={{
            position: "fixed",
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`,
            minWidth: `${dropdownPosition.minWidth}px`,
            backgroundColor: "#fff",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            zIndex: 99999,
            maxHeight: "300px",
            overflowY: "auto",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {options.map((option) => (
            <div
              key={option.value}
              onClick={(e) => handleOptionClick(option, e)}
              style={{
                padding: "10px",
                cursor: "pointer",
                fontSize: "1rem",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: returnObject
                  ? value?.value === option.value
                    ? "var(--pile-green)"
                    : "#fff"
                  : value === option.value
                  ? "var(--pile-green)"
                  : "#fff",
                borderBottom: "1px solid #eee",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "var(--pile-green)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = returnObject
                  ? value?.value === option.value
                    ? "var(--pile-green)"
                    : "#fff"
                  : value === option.value
                  ? "var(--pile-green)"
                  : "#fff")
              }
            >
              {icon && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#22ccb2",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    margin: 0,
                    padding: 1,
                  }}
                >
                  {icon}
                </span>
              )}
              <span>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default CustomDropdown;
